var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.26326 2.23268C8.29659 1.26602 6.96992 0.666016 5.49659 0.666016C2.54992 0.666016 0.169922 3.05268 0.169922 5.99935C0.169922 8.94602 2.54992 11.3327 5.49659 11.3327C7.98326 11.3327 10.0566 9.63268 10.6499 7.33268H9.26326C8.71659 8.88601 7.23659 9.99935 5.49659 9.99935C3.28992 9.99935 1.49659 8.20602 1.49659 5.99935C1.49659 3.79268 3.28992 1.99935 5.49659 1.99935C6.60326 1.99935 7.58992 2.45935 8.30992 3.18602L6.16326 5.33268H10.8299V0.666016L9.26326 2.23268Z",
    fill: "#1FA37C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.790f238bbaacab02225ee81d06d27510.svg";
export { ForwardRef as ReactComponent };